import { render, staticRenderFns } from "./addpackagename.vue?vue&type=template&id=28761852&"
import script from "./addpackagename.vue?vue&type=script&lang=js&"
export * from "./addpackagename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28761852')) {
      api.createRecord('28761852', component.options)
    } else {
      api.reload('28761852', component.options)
    }
    module.hot.accept("./addpackagename.vue?vue&type=template&id=28761852&", function () {
      api.rerender('28761852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/components/addpackagename.vue"
export default component.exports